export default __webpack_public_path__ + "static/media/Zoo Map.5e5dbc8a.svg";